.main {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
